import React from 'react';

interface LogoProps {
  onClick?: () => void;
}

export function Logo({ onClick }: LogoProps) {
  return (
    <div 
      className="flex items-center cursor-pointer" 
      onClick={onClick}
    >
      <img 
        src="https://i.imgur.com/XGlIJLi.png" 
        alt="AutoInsurance Logo" 
        className="h-8"
      />
    </div>
  );
}